import React from "react";
import { Instagram, Facebook, Youtube } from "lucide-react";

const redes = [
  { id: "youtube", href: "https://www.youtube.com/@dracometa", label: "YouTube", Icon: Youtube },
  { id: "instagram", href: "https://www.instagram.com/doctora_cometa", label: "Instagram", Icon: Instagram },
  { id: "tiktok", href: "https://www.tiktok.com/@dra..cometa", label: "TikTok", Icon: null },
  { id: "facebook", href: "https://www.facebook.com/profile.php?id=61589307333290", label: "Facebook", Icon: Facebook },
];

export const SocialRow = ({ className = "", dark = false }) => (
  <div className={`flex flex-wrap items-center gap-3 ${className}`} data-testid="social-row">
    <span className={`text-xs tracking-[0.3em] ${dark ? "text-cometa-tinta/60" : "text-cometa-crema/60"}`}>SÍGUEME EN</span>
    {redes.map(({ id, href, label, Icon }) => (
      <a key={id} href={href} target="_blank" rel="noreferrer" aria-label={label} data-testid={`social-row-${id}`}
        className={`inline-flex items-center gap-2 px-4 py-2 rounded-full border text-sm font-semibold transition hover:-translate-y-0.5 ${dark ? "border-cometa-tinta/20 hover:bg-cometa-tinta hover:text-cometa-crema" : "border-cometa-crema/30 hover:bg-cometa-crema hover:text-cometa-tinta"}`}>
        {Icon ? <Icon size={16} /> : <span className="font-bold text-xs">Tk</span>} {label}
      </a>
    ))}
  </div>
);
